import { MARKET } from '@/market'

/**
 * Single source of truth for every way a visitor can reach Samly.
 *
 * The lead form is intentionally disabled: `sendContactForm` posts to
 * VITE_CONTACT_API_URL, which has no backend behind it yet. Until that endpoint
 * exists, the CTA modal shows these contacts instead. To re-enable the form,
 * flip LEAD_FORM_ENABLED to true and set VITE_CONTACT_API_URL in the build env
 * (.github/workflows/deploy.yml) — nothing else needs to change.
 */
export const LEAD_FORM_ENABLED = false

/** Contacts of the market this build targets (src/market). */
export const CONTACT = MARKET.contact
